import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../redux/slices/authSlice';
import useInactivityLogout from '../hooks/useInactivityLogout';
import { useLanguage } from '../context/LanguageContext';

/**
 * Renders nothing. Listens for user activity and logs out after 30 min inactivity when authenticated.
 */
export default function InactivityLogout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { addLanguagePrefix } = useLanguage();
  const { isAuthenticated } = useSelector((state) => state.auth);

  const handleLogout = useCallback(() => {
    dispatch(logout());
    navigate(addLanguagePrefix('/login'));
  }, [dispatch, navigate, addLanguagePrefix]);

  useInactivityLogout(handleLogout, isAuthenticated);
  return null;
}
